/* eslint-disable camelcase */
<template>
  <div>
    <div class="task">
      <h3 class="task__title">Tasks</h3>
      <div class="task__content">
        <div class="subtask" v-for="(item, index) in tasks" :key="index">
          <div class="subtask__mark">
            <div class="subtask__mark--chart">
              {{ item.batch_type | mark_filter }}
            </div>
          </div>
          <div class="subtask__title">
            <div class="subtask__title--main">{{ item.batch_type }}</div>
            <div class="subtask__title--last">
              Batch date: {{ item.batch_date }}。您已標記：
              {{ item.your_labelled_count }} 個檔案
            </div>
          </div>
          <div class="subtask__num">
            ( {{ item.unlabelled_count }} / {{ item.total_count }} )
          </div>
          <div class="subtask__label">
            <div
              v-if="item.unlabelled_count === 0 && item.rejected_count === 0"
            >
              <div>
                <button
                  class="btn btn-primary mg-r-ten btn-fashion"
                  @click.prevent="commit(item)"
                  style="margin:5px"
                >
                  Commit
                </button>
              </div>

              <div>
                <button
                  class="btn btn-primary mg-r-ten btn-fashion"
                  @click.prevent="review(item)"
                  style="margin:5px"
                >
                  Review
                </button>
              </div>
            </div>
            <div v-else>
              <div>
                <button
                  class="btn btn-info subtask__label--btn"
                  @click.prevent="golabel(item.batch_type)"
                  style="margin:5px"
                >
                  Label
                </button>
              </div>

              <!-- <p class="subtask__label--tips">(10 / 200)</p> -->
              <div>
                <button
                  class="btn btn-danger subtask__label--btn"
                  @click.prevent="goCorrect(item)"
                  style="margin:5px"
                >
                  Reject ({{ item.rejected_count }})
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import client from "@/api/client";

export default {
  data() {
    return {
      tasks: [],
      type: "",
      role: localStorage.role === "admin"
    };
  },
  methods: {
    commit(item) {
      const vm = this;
      const loader = vm.$loading.show();
      client
        .post(`/task/${item.batch_type}/${item.batch_date}/commit`)
        .then(res => {
          loader.hide();
          this.getTaskList();
        })
        .catch(err => {
          loader.hide();
          if (err === 401) {
            vm.$router.push("/login");
          }
        });
    },
    review(item) {
      const { batch_date } = item.batch_date;
      if (item.batch_type === "sleep_main") {
        this.$router.push({
          name: "review_sleep_main",
          params: {
            batch_date
          }
        });
      } else if (item.batch_type === "sleep_detection") {
        this.$router.push({
          name: "review_sleep_detection",
          params: {
            batch_date
          }
        });
      } else if (item.batch_type === "sleep_occl") {
        this.$router.push({
          name: "review_sleep_occl",
          params: {
            batch_date
          }
        });
      }
    },
    golabel(batch_type) {
      // console.log(data);
      if (batch_type === "sleep_main") {
        this.$router.push({
          name: "LabelSleepMain",
          params: {
            type: "label"
          }
        });
      } else if (batch_type === "audio") {
        this.$router.push("/task/audio");
      } else if (batch_type === "audio_v2") {
        this.$router.push("/task/audio_v2");
      } else if (batch_type === "sleep_occl") {
        this.$router.push("/task/sleep_occl");
      } else if (batch_type === "sleep_detection") {
        this.$router.push("/task/sleep_detection");
      } else if (batch_type === "live_main") {
        this.$router.push("/task/live_main");
      } else if (batch_type === "caregiver") {
        this.$router.push("/task/caregiver");
      }
      // else if (data === "live_main") {
      //   // this.$router.push("");
      // }
    },
    goCorrect(item) {
      let correctPathName = "CorrectSleepMain";
      if (item.batch_type === "sleep_occl") {
        correctPathName = "CorrectSleepOccl";
      } else if (item.batch_type === "sleep_detection") {
        correctPathName = "CorrectSleepDetection";
      }

      this.$router.push({
        name: `${correctPathName}`,
        params: {
          type: "correct",
          batch_date: item.batch_date
        }
      });
    },
    getTaskList() {
      const vm = this;
      const loader = vm.$loading.show();
      client
        .get("/task")
        .then(res => {
          loader.hide();
          console.log(`get response: ${res}`);
          vm.tasks = res.results;
        })
        .catch(err => {
          loader.hide();
          if (err === 401) {
            vm.$router.push("/login");
          }
        });
    }
  },
  filters: {
    mark_filter(data) {
      return data.substr(0, 1);
    }
  },
  mounted() {
    if (localStorage.token.length > 0) {
      this.getTaskList();
    } else {
      this.$router.push("/login");
    }
  }
};
</script>
